import clsx from 'clsx'
import NavLink from 'routes/components/NavLink'
import classes from './ConnectorsGrid.module.css'
import { LINKS } from 'routes/constants'

export type ConnectorType = {
  key: string
  name: string
  iconSrc: string
  status: 'production' | 'planned' | 'beta'
}

export default function ConnectorsGrid({
  connectors,
}: {
  connectors: ConnectorType[]
}) {
  const result: JSX.Element[] = []

  connectors?.forEach(({ key, name, iconSrc, status }) => {
    result.push(
      <div className={classes.connector} key={key}>
        <div
          className={clsx(
            classes.icon,
            status === 'planned' && classes.icon__planned,
          )}
        >
          {/* We don't have this item yet */}
          {/*<span className={classes.tag}>Ai</span>*/}
          <img className={classes.icon_image} src={iconSrc} alt={name} />
        </div>
        <div className={classes.name}>
          <NavLink
            className={classes.name_link}
            href={`${LINKS.CONNECTORS}/${key}`}
          >
            {name}
          </NavLink>
        </div>
      </div>,
    )
  })

  Array.from(Array(10).keys()).forEach((key) => {
    result.push(<div className={classes.connectorPlaceholder} key={key} />)
  })

  return <div className={classes.grid}>{result}</div>
}
